/**
 * star.jsx
 *
 * @Author: jruif
 * @Date: 2017/8/14 上午10:28
 */

import React from 'react';
import PropTypes from 'prop-types';
// import classNames from 'classnames';
import { Tooltip, Modal, Icon, Button } from 'neatui';
import { connect } from 'react-redux';
import ajax from '../../util/ajax';
import './star.scss';

class Star extends React.PureComponent {
  static propTypes = {
    user: PropTypes.object,
  };

  static defaultProps = {};
  constructor(props) {
    super(props);
    this.confirmModal = null;
  }

  //constructor(props, context) {
  //    super(props, context);
  //}

  applyOnline = () => {
    const { location } = window;
    const { user, updateState, router } = this.props;
    this.confirmModal = Modal.confirm({
      className: 'star-modal',
      content: (
        <div className="modal-con" key="desc-con">
          <div className="modal-con-title" key="desc-title">
            <span key="desc-warn">提示</span>
            <Icon
              key="desc-icon-cancel"
              type="cancel-1"
              className="icon-con"
              onClick={() => this.confirmModal.close()}
            />
          </div>
          <p key="desc-text">
            请仔细阅读帐号申请上线不通过原因并按照要求修改帐号资料，再提交上线申请。
          </p>
          <p key="desc-text1">（每个帐号仅有两次再申请上线的机会）</p>
        </div>
      ),
      okText: '修改资料',
      cancelText: '提交审核',
      title: '',
      hasCloseBtnOnHeader: true,
      hasHeader: true,
      iconType: '',
      onOk: () => {
        location.href = `/info.html${router.location.search}`;
      },
      onCancel: () => {
        ajax(
          '/online/apply.do',
          {
            method: 'post',
            data: {
              wemediaId: user.wemediaId,
            },
          },
          rs => {
            Modal.success({
              content: '您的上线申请已提交成功，审核将在24小时内完成，记得回来哟！',
            });
            // 更新用户状态
            updateState && updateState();
          },
        );
      },
    });
  };

  render() {
    const { user } = this.props;
    let makeStar = [];
    for (let i = 0; i < 5; i++) {
      makeStar.push(
        <Icon type="star" key={`star-${i}`} className={i < user.star ? 'light' : ''} />,
      );
    }

    let applyOnline,
      onlineBtn = (
        <button className="apply-ok btn-style" onClick={this.applyOnline}>
          申请上线
        </button>
      );

    if (user.auditState === -99) {
      // 默认值：请求出错的时候用来显示
      applyOnline = <span className="apply-warning">暂无信息</span>;
    } else if (user.auditState === 0) {
      applyOnline = (
        <Tooltip
          content={<span className="apply-warning">帐号审核中</span>}
          title="帐号正在审核中，请耐心等待"
          position="bottomRight"
        />
      );
    } else if (user.auditState === 1) {
      switch (user.onlineState) {
        case 0:
        case 3:
          if (user.articleCount < user.thresh && user.local === 1) {
            // applyOnline = (
            //   <Tooltip
            //     content={<span className="apply-warning">申请上线</span>}
            //     title={`您还需要发布${user.thresh - user.articleCount}篇文章才可以申请上线`}
            //     position="bottomRight"
            //   />
            // );
            applyOnline = onlineBtn;
          } else if (user.onlineState === 0) {
            applyOnline = onlineBtn;
          } else if (user.onlineState === 3) {
            applyOnline = (
              <Tooltip
                content={onlineBtn}
                position="bottomRight"
                title="未通过上线审核，请修改信息后重新申请上线"
              />
            );
          }
          applyOnline = (
            <span>
              <span className="apply-online-tips">
                {user.onlineState === 0 ? '未申请' : '已拒绝'}
              </span>
              {applyOnline}
            </span>
          );
          break;
        case 1:
          applyOnline = (
            <span className="apply-warning apply-warning-title">
              <span>上线审核中</span>
              <span className="apply-warning-tooltip">
                {user.faceDetectFlag
                  ? '实名认证完成后将受理您的申请，请耐心等待审核'
                  : '请耐心等待审核'}
              </span>
            </span>
          );
          // Tooltip 弃用
          <Tooltip
            content={<span className="apply-warning">上线审核中</span>}
            title="实名认证完成后将受理您的申请，请耐心等待审核"
            position="bottomRight"
          />;
          break;
        case 2:
          applyOnline = <span className="apply-warning">已上线</span>;
          break;
        case 4:
          applyOnline = (
            <span>
              <span className="apply-online-tips">已下线</span>
              <Tooltip
                content={onlineBtn}
                position="bottomRight"
                title="你的帐号已被管理员下线，请按要求修改后重新申请上线"
              />
            </span>
          );
          break;
        case 7:
          applyOnline = (
            <Tooltip
              content={<span className="apply-warning">已封禁</span>}
              title="你的帐号已被管理员封禁，请联系管理员"
              position="bottomRight"
            />
          );
          break;
        case 9:
          applyOnline = (
            <Tooltip
              content={<span className="apply-warning">已拒绝</span>}
              title="您的账号不符合上线条件，已被永久拒绝"
              position="bottomRight"
            />
          );
          break;
        default:
          break;
      }
    } else if (user.auditState === 2) {
      applyOnline = <span className="apply-warning">未通过帐号审核</span>;
    } else {
      applyOnline = <span className="apply-warning">已封禁</span>;
    }

    return user.star >= 0 ? <span>{makeStar}</span> : applyOnline;
  }
}

// export default Star;
export default connect(state => ({ router: state.router }))(Star);
